import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	initialized: false,
	isSendSmsModalOpen: false,
	smsDraft: null,
	processing: false,
};
